import React from "react";
import { hasModuleAccess } from "./rolePermissions";
import ProtectedRoute from "../components/ProtectedRoute";

import AllNews from "../views/auth/newsPost/AllNews";
import News from "../views/auth/newsPost/News";
import CreateNews from "../views/auth/newsPost/CreateNewPost";
import UpdateNews from "../views/auth/newsPost/UpdateNewPost";

import Knowledges from "../views/auth/knowledges/Knowledges";
import CreateKnowledge from "../views/auth/knowledges/CreateKnowledge";
import Knowledge from "../views/auth/knowledges/Knowledge";
import UpdateKnowledge from "../views/auth/knowledges/UpdateKnowledge";

import Privileges from "../views/auth/partnership_hospital/Partners";
import Privilege from "../views/auth/partnership_hospital/Partner";
import CreatePrivilege from "../views/auth/partnership_hospital/CreatePartner";
import UpdatePrivilege from "../views/auth/partnership_hospital/UpdatePartners";

import Emergencies from "../views/auth/emergencies/Emergencies";
import Emergencie from "../views/auth/emergencies/Emergencie";
import CreateEmergencies from "../views/auth/emergencies/CreateEmergencies";
import UpdateEmergencies from "../views/auth/emergencies/UpdateEmergencies";

import Banners from "../views/auth/banners/Banners";
import Banner from "../views/auth/banners/Banner";
import CreateBanner from "../views/auth/banners/CreateBanner";
import UpdateBanner from "../views/auth/banners/UpdateBanner";

import Onboardings from "../views/auth/onboardings/Onboardings";
import Onboarding from "../views/auth/onboardings/Onboarding";
import CreateOnboarding from "../views/auth/onboardings/CreateOnboarding";
import UpdateOnboarding from "../views/auth/onboardings/UpdateOnboarding";

import ClaimFiles from "../views/auth/claimFiles/ClaimFiles";
import ClaimFile from "../views/auth/claimFiles/ClaimFile";
import LoanFiles from "../views/auth/loanFiles/LoanFiles";
import LoanFile from "../views/auth/loanFiles/LoanFile";
import PolicyDocuments from "../views/auth/policy_documents/PolicyDocuments";
import DetailPolicyDocument from "../views/auth/policy_documents/DetailPolicyDocument";
import CreatePolicyDocument from "../views/auth/policy_documents/CreatePolicyDocument";
import UpdatePolicyDocument from "../views/auth/policy_documents/UpdatePolicyDocument";

import Users_level_2 from "../views/auth/user_level_2/Users2";
import User_level_2 from "../views/auth/user_level_2/User2";
import Users_level_3 from "../views/auth/userLevel3/User3s";
import User_level_3 from "../views/auth/userLevel3/User3";
import CompanyUsers from "../views/auth/company_user/CompanyUsers";
import CompanyUser from "../views/auth/company_user/CompanyUser";

import Inquirys from "../views/auth/inquiry/inquirys";
import Inquiry from "../views/auth/inquiry/inquiry";
import FAQs from "../views/auth/faq/GetAllFaqs";
import DetailFaq from "../views/auth/faq/DetailFaq";
import CreateFaq from "../views/auth/faq/CreateFaq";
import UpdateFaq from "../views/auth/faq/UpdateFaq";
import PopupMessages from "../views/auth/popup_messages/PopupMessages";
import PopupMessage from "../views/auth/popup_messages/PopupMesage";
import CreatePopupMessage from "../views/auth/popup_messages/CreatePopupMessage";
import UpdatePopupMessage from "../views/auth/popup_messages/UpdatePopupMessage";
import UserManual from "../views/auth/user_manual/GetAllUserManual";
import DetailUserManual from "../views/auth/user_manual/DetailUserManual";
import CreateUserManual from "../views/auth/user_manual/CreateUserManual";
import UpdateUserManual from "../views/auth/user_manual/UpdateUserManual";
import BankInfos from "../views/auth/bank_infos/BankInfos";
import CreateBankInfo from "../views/auth/bank_infos/CreateBankInfo";
import UpdateBankInfo from "../views/auth/bank_infos/UpdateBankInfo";
import PrestigeCards from "../views/auth/prestige_cards/PrestigeCards";
import CreatePrestigeCard from "../views/auth/prestige_cards/CreatePrestigeCard";
import UpdatePrestigeCard from "../views/auth/prestige_cards/UpdatePrestigeCard";
import RolePermissions from "../views/auth/role_permissions/RolePermissions";
import DashboardUsers from "../views/auth/dashboard_users/DashboardUsers";
import DashboardModules from "../views/auth/dashboard_modules/DashboardModules";

/**
 * Builds the full route list tagged by module. homeAlert is passed into pages that need it.
 * @param {(message: string, isError?: boolean) => void} homeAlert
 */
export const buildRouteRegistry = (homeAlert) => [
  // News Posts
  { module: "newsPosts", path: "/all_news", element: <AllNews /> },
  {
    module: "newsPosts",
    path: "/news/:id",
    element: <News homeAlert={homeAlert} />,
  },
  {
    module: "newsPosts",
    path: "/createNew",
    element: <CreateNews homeAlert={homeAlert} />,
  },
  {
    module: "newsPosts",
    path: "/updateNew/:id",
    element: <UpdateNews homeAlert={homeAlert} />,
  },

  // Knowledges
  { module: "knowledges", path: "/knowledges", element: <Knowledges /> },
  {
    module: "knowledges",
    path: "/knowledges/:id",
    element: <Knowledge homeAlert={homeAlert} />,
  },
  {
    module: "knowledges",
    path: "/createKnowledge",
    element: <CreateKnowledge homeAlert={homeAlert} />,
  },
  {
    module: "knowledges",
    path: "/updateKnowledge/:id",
    element: <UpdateKnowledge homeAlert={homeAlert} />,
  },

  // Privileges
  { module: "privileges", path: "/privileges", element: <Privileges /> },
  {
    module: "privileges",
    path: "/privilege/:id",
    element: <Privilege homeAlert={homeAlert} />,
  },
  {
    module: "privileges",
    path: "/createPartner",
    element: <CreatePrivilege homeAlert={homeAlert} />,
  },
  {
    module: "privileges",
    path: "/updatePartner/:id",
    element: <UpdatePrivilege homeAlert={homeAlert} />,
  },

  // Banners
  { module: "banners", path: "/banners", element: <Banners /> },
  {
    module: "banners",
    path: "/banners/:id",
    element: <Banner homeAlert={homeAlert} />,
  },
  {
    module: "banners",
    path: "/createBanner",
    element: <CreateBanner homeAlert={homeAlert} />,
  },
  {
    module: "banners",
    path: "/updateBanner/:id",
    element: <UpdateBanner homeAlert={homeAlert} />,
  },

  // Emergencies
  { module: "emergencies", path: "/emergencies", element: <Emergencies /> },
  {
    module: "emergencies",
    path: "/emergencies/:id",
    element: <Emergencie homeAlert={homeAlert} />,
  },
  {
    module: "emergencies",
    path: "/createEmergencies",
    element: <CreateEmergencies homeAlert={homeAlert} />,
  },
  {
    module: "emergencies",
    path: "/updateEmergencies/:id",
    element: <UpdateEmergencies homeAlert={homeAlert} />,
  },

  // Onboardings
  { module: "onboardings", path: "/onboardings", element: <Onboardings /> },
  {
    module: "onboardings",
    path: "/onboardings/:id",
    element: <Onboarding homeAlert={homeAlert} />,
  },
  {
    module: "onboardings",
    path: "/createOnboarding",
    element: <CreateOnboarding homeAlert={homeAlert} />,
  },
  {
    module: "onboardings",
    path: "/updateOnboarding/:id",
    element: <UpdateOnboarding homeAlert={homeAlert} />,
  },

  // Claim Files
  { module: "claimFiles", path: "/claimFiles", element: <ClaimFiles /> },
  {
    module: "claimFiles",
    path: "/claimFiles/:insurance_id",
    element: <ClaimFile homeAlert={homeAlert} />,
  },

  // Loan Files
  { module: "loanFiles", path: "/loanFiles", element: <LoanFiles /> },
  {
    module: "loanFiles",
    path: "/loanFiles/:insurance_id",
    element: <LoanFile homeAlert={homeAlert} />,
  },

  // Policy Documents
  {
    module: "policyDocuments",
    path: "/policy-documents",
    element: <PolicyDocuments />,
  },
  {
    module: "policyDocuments",
    path: "/policy-documents/create",
    element: <CreatePolicyDocument homeAlert={homeAlert} />,
  },
  {
    module: "policyDocuments",
    path: "/policy-documents/:scope/:id",
    element: <DetailPolicyDocument homeAlert={homeAlert} />,
  },
  {
    module: "policyDocuments",
    path: "/policy-documents/edit/:scope/:id",
    element: <UpdatePolicyDocument homeAlert={homeAlert} />,
  },

  // Prestige Card
  {
    module: "prestigeCard",
    path: "/prestige-cards",
    element: <PrestigeCards homeAlert={homeAlert} />,
  },
  {
    module: "prestigeCard",
    path: "/createPrestigeCard",
    element: <CreatePrestigeCard homeAlert={homeAlert} />,
  },
  {
    module: "prestigeCard",
    path: "/updatePrestigeCard/:id",
    element: <UpdatePrestigeCard homeAlert={homeAlert} />,
  },

  // User Level 2
  { module: "userLevel2", path: "/users2", element: <Users_level_2 /> },
  {
    module: "userLevel2",
    path: "/users2/:id",
    element: <User_level_2 homeAlert={homeAlert} />,
  },

  // User Level 3
  { module: "userLevel3", path: "/users3", element: <Users_level_3 /> },
  {
    module: "userLevel3",
    path: "/users3/:id",
    element: <User_level_3 homeAlert={homeAlert} />,
  },

  // Company User
  { module: "companyUser", path: "/companys", element: <CompanyUsers /> },
  {
    module: "companyUser",
    path: "/companys/:id",
    element: <CompanyUser homeAlert={homeAlert} />,
  },

  // Inquiry
  { module: "inquiry", path: "/inquiry", element: <Inquirys /> },
  {
    module: "inquiry",
    path: "/inquiry/:id",
    element: <Inquiry homeAlert={homeAlert} />,
  },

  // FAQs
  {
    module: "faqs",
    path: "/faqs",
    element: <FAQs homeAlert={homeAlert} />,
  },
  {
    module: "faqs",
    path: "/faqs/:id",
    element: <DetailFaq homeAlert={homeAlert} />,
  },
  {
    module: "faqs",
    path: "/faqs/create-faq",
    element: <CreateFaq homeAlert={homeAlert} />,
  },
  {
    module: "faqs",
    path: "/faqs/edit/:id",
    element: <UpdateFaq homeAlert={homeAlert} />,
  },

  // Popup
  {
    module: "popup",
    path: "/popup-messages",
    element: <PopupMessages homeAlert={homeAlert} />,
  },
  {
    module: "popup",
    path: "/popup-messages/:id",
    element: <PopupMessage homeAlert={homeAlert} />,
  },
  {
    module: "popup",
    path: "/popup-messages/update/:id",
    element: <UpdatePopupMessage homeAlert={homeAlert} />,
  },
  {
    module: "popup",
    path: "/popup-message/create",
    element: <CreatePopupMessage homeAlert={homeAlert} />,
  },

  // User Manual
  {
    module: "userManual",
    path: "/user-manual",
    element: <UserManual homeAlert={homeAlert} />,
  },
  {
    module: "userManual",
    path: "/user-manual/:id",
    element: <DetailUserManual homeAlert={homeAlert} />,
  },
  {
    module: "userManual",
    path: "/user-manual/create",
    element: <CreateUserManual homeAlert={homeAlert} />,
  },
  {
    module: "userManual",
    path: "/user-manual/update/:id",
    element: <UpdateUserManual homeAlert={homeAlert} />,
  },

  // Bank Information
  {
    module: "bankInformation",
    path: "/bank-infos",
    element: <BankInfos homeAlert={homeAlert} />,
  },
  {
    module: "bankInformation",
    path: "/createBankInfo",
    element: <CreateBankInfo homeAlert={homeAlert} />,
  },
  {
    module: "bankInformation",
    path: "/updateBankInfo/:id",
    element: <UpdateBankInfo homeAlert={homeAlert} />,
  },
  {
    module: "rolePermissions",
    path: "/role-permissions",
    element: <RolePermissions homeAlert={homeAlert} />,
  },
  {
    module: "dashboardUsers",
    path: "/dashboard-users",
    element: <DashboardUsers homeAlert={homeAlert} />,
  },
  {
    module: "dashboardModules",
    path: "/dashboard-modules",
    element: <DashboardModules homeAlert={homeAlert} />,
  },
];

export const getRegisteredModuleKeys = (homeAlert) => {
  const registry = buildRouteRegistry(homeAlert);
  return new Set(registry.map((route) => route.module));
};

export const getRoutesForRole = (
  role,
  homeAlert,
  moduleKeys,
  catalog,
  registeredModuleKeys
) => {
  const registry = buildRouteRegistry(homeAlert);
  const registered =
    registeredModuleKeys || getRegisteredModuleKeys(homeAlert);
  return registry
    .filter((route) => hasModuleAccess(moduleKeys, route.module))
    .map((route) => ({
      ...route,
      element: (
        <ProtectedRoute
          module={route.module}
          moduleKeys={moduleKeys}
          catalog={catalog}
          registeredModuleKeys={registered}
        >
          {route.element}
        </ProtectedRoute>
      ),
    }));
};
